/**
 * Converts Slack emoji codes (e.g., :rocket:) to Unicode emojis (e.g., 🚀)
 * Uses node-emoji library for comprehensive emoji support
 */
import { emojify } from 'node-emoji';

/**
 * Converts Slack emoji shortcodes to Unicode emojis
 * @param {string} text - Text containing :emoji_code: patterns
 * @returns {string} Text with emoji codes replaced by actual emojis
 *
 * Examples:
 *   "Great work :rocket:" → "Great work 🚀"
 *   "Thanks :heart:" → "Thanks ❤️"
 *   ":+1: awesome!" → "👍 awesome!"
 *
 * Note: Custom workspace emojis will remain as :custom_emoji:
 * (would need Slack API integration to fetch custom emoji URLs)
 */
export const convertSlackEmojis = (text) => {
  if (!text) return text;

  // node-emoji's emojify function handles :emoji_code: format
  return emojify(text);
};

export default convertSlackEmojis;
